import { IIdKeyEntityBase } from "../../types/models/base/IIdKeyEntityBase";
import { UpdateDataService } from "./UpdateDataService";

export abstract class BaseDataService<TModel extends IIdKeyEntityBase<number>, TQuery> extends UpdateDataService<TModel, TQuery, number> {

}